module.exports = __webpack_public_path__ + "static/media/facebook.cd0d2a4c.svg";